import React, {useState, useEffect, useContext, useRef } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonInput, IonList } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';
import { Application_Details } from '../../../zInternal_Features/merchant/components/ViewApplication_DetailData';
import { Onboarding_Details } from '../../../zInternal_Features/merchant/components/ViewOnboarding_DetailData';

import '../../../../css/qavaApp.css';


export function ViewReq_ApplicationsRecievedList(props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);

    const [acctID, setAcctID] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [viewApplicationList, setViewApplicationList] = useState([]);
    let [viewOnboardingtionList, setViewOnboardingList] = useState([]);


    let [openApplicationModal, setOpenApplicationModal] = useState(false);
    let [openOnboardingModal, setOpenOnboardingModal] = useState(false);

    let [requisitionID, setRequisitionID] = useState(false);
    let [requisitionName, setRequisitionName] = useState(false);
    let [applicationID, setApplicationID] = useState(null);
    let [applicant_firstName, setApplicant_firstName] = useState(null);
    let [applicant_lastName, setApplicant_lastName] = useState(null);


   //getOccupiedRoomDetailData(instant_checkInRoomID) {
function viewApplicaitonList () {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_applications_recieved",
                user: acctID,
                xJobRequisitionID: props.data.requisitionID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            //alert(res);

            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');


                setViewApplicationList((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        requisitionID: cols[0], 
                        application_id: cols[1], 
                        requisitionName: cols[2], 
                        company_role: cols[3], 
                        applicant_first_name: cols[4], 
                        applicant_middle_name: cols[5], 
                        applicant_last_name: cols[6], 
                        applicant_phone_number: cols[7], 
                        applicant_email_address: cols[8], 
                        date_recieved: cols[9], 
                        application_status: cols[10],
    
                    })
                });
            } 
        })

    };

    function viewEmployeeOnboardingList () {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: "74503_employee_onboarding_list",
                user: acctID,
                xJobRequisitionID: props.data.requisitionID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'internal_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {


            let rows = res.toString().split('~~~');

            for (let rownum = 0; rownum < rows.length - 1; ++rownum)
            {
                let cols = rows[rownum].split('|');

                setViewOnboardingList((prevViewRequisitionList) => {
                    return prevViewRequisitionList.concat({
                        requisition_id: cols[0], 
                        application_id: cols[1], 
                        requisition_name: cols[2], 
                        company_role: cols[3], 
                        applicant_first_name: cols[4], 
                        applicant_middle_name: cols[5], 
                        applicant_last_name: cols[6], 
                        applicant_phone_number: cols[7], 
                        applicant_email_address: cols[8], 
                        applicant_address_number: cols[9], 
                        applicant_street_name: cols[10], 
                        applicant_city: cols[11], 
                        applicant_city_district: cols[12], 
                        applicant_country_region: cols[13], 
                        applicant_country: cols[14], 
                        applicant_digital_address: cols[15], 
                        date_recieved: cols[16], 
                        application_status: cols[17],
    
                    })
                });
            } 
        })

    };
    
    function applicationDetailModalHandler(event) {

        setApplicationID(event[1]);
        setApplicant_firstName(event[2]);
        setApplicant_lastName(event[3]);
        setRequisitionID(event[4]);
        setRequisitionName(event[5]);
        setOpenApplicationModal(event[0]);

    }

    function onboardingDetailModalHandler(event) {

        setApplicationID(event[1]);
        setApplicant_firstName(event[2]);
        setApplicant_lastName(event[3]);
        setRequisitionID(event[4]);
        setRequisitionName(event[5]);
        setOpenOnboardingModal(event[0]);

    }

    function closeModalHandler() {

        setViewApplicationList([]);
        props.closeModal(false);
    }

    useEffect(() => {

        viewApplicaitonList();
        viewEmployeeOnboardingList();

    }, [])   

    return (
        <React.Fragment>
                    {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
                    <IonContent className='occupiedDetails_gridContent'>
            <IonList>
                <IonSlides>
                    <IonSlide>
                        <div id='EmployeeOverviewGrid' style={{display: 'inline-block'}}>
                            <h3> Posted Jobs </h3>
                            <IonGrid className='gridText'>
                                <IonRow className='gridResultHeaders'>
                                        <IonCol size='1' className='gridResultColumns'>Application ID</IonCol>
                                        <IonCol size='3' className='gridResultColumns'>Name</IonCol>
                                        <IonCol size='3' className='gridResultColumns'>Action</IonCol>
                                        <IonCol className='gridResultColumns'>Action</IonCol>
                                </IonRow>
                                {viewApplicationList.map((detailData) =>   {
                                    return (
                                        <IonRow className='gridResultBody'>
                                            <IonCol size='1' className='gridResultColumns'>{detailData.application_id}</IonCol>
                                            <IonCol size='3' className='gridResultColumns'>{detailData.requisitionName}</IonCol>
                                            <IonCol size='3' className='gridResultColumns'>{detailData.applicant_first_name+ " "+detailData.applicant_last_name}</IonCol>
                                            <IonCol size='5' className={detailData.application_status == 'interview' ? 'yellowButton' : ''}>
                                                {/*<IonButton className='gridResultColumnButton' > Image </IonButton>*/}
                                                <IonButton onClick={() => applicationDetailModalHandler([true, detailData.application_id, detailData.applicant_first_name, detailData.applicant_lastName, detailData.requisitionID, detailData.requisitionName])}> Details </IonButton>
                                  </IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                            <IonButton onClick={() => closeModalHandler(true)}> Close </IonButton>
                        </div>
                    </IonSlide>

                    <IonSlide>
                        <div id='EmployeeOverviewGrid' style={{display: 'inline-block'}}>
                            <h3> Employee Onboarding </h3>
                            <IonGrid className='gridText'>
                                <IonRow className='gridResultHeaders'>
                                        <IonCol size='1' className='gridResultColumns'>Onboarding ID</IonCol>
                                        <IonCol size='3' className='gridResultColumns'>Name</IonCol>
                                        <IonCol size='3' className='gridResultColumns'>Action</IonCol>
                                        <IonCol className='gridResultColumns'>Action</IonCol>
                                </IonRow>
                                {viewOnboardingtionList.map((detailData) =>   {
                                    return (
                                        <IonRow className='gridResultBody'>
                                            <IonCol size='1' className='gridResultColumns'>{detailData.application_id}</IonCol>
                                            <IonCol size='3' className='gridResultColumns'>{detailData.requisitionName}</IonCol>
                                            <IonCol size='3' className='gridResultColumns'>{detailData.applicant_first_name+ " "+detailData.applicant_last_name}</IonCol>
                                            <IonCol size='2' className='gridResultColumns'>
                                                {/*<IonButton className='gridResultColumnButton' > Image </IonButton>*/}
                                                <IonButton className='gridResultColumnButton' onClick={() => onboardingDetailModalHandler([true, detailData.application_id, detailData.applicant_first_name, detailData.applicant_lastName, detailData.requisitionID, detailData.requisitionName])}> Details </IonButton>
                                            </IonCol>
                                        </IonRow>
                                    )
                                }
                                )}
                            </IonGrid>
                            <IonButton onClick={() => closeModalHandler(true)}> Close </IonButton>
                        </div>
                    </IonSlide>

                </IonSlides>


            </IonList>

            </IonContent>

                    {/*<CreateOnboardingProcess openModal= { createRequisitionModal } closeModal={() => setCeateRequisitionModal(false)}></CreateOnboardingProcess>*/}

                    {openApplicationModal == true &&  <Application_Details openModal= { openApplicationModal } closeModal={() => setOpenApplicationModal(false)} data={{
            applicationID: applicationID, 
            applicant_first_name: applicant_firstName, 
            applicant_last_name: applicant_lastName, 
            requisitionID: props.data.requisitionID, 
            requisitionName: requisitionName,
                                }}></Application_Details>}

            {openOnboardingModal == true &&  <Onboarding_Details openModal= { openOnboardingModal } closeModal={() => setOpenOnboardingModal(false)} data={{
                        applicationID: applicationID, 
                        applicant_first_name: applicant_firstName, 
                        applicant_last_name: applicant_lastName, 
                        requisitionID: props.data.requisitionID, 
                        requisitionName: requisitionName,
                                            }}></Onboarding_Details>}

        {/* <DeleteApplication openModal= { deleteRequisitionModal } closeModal={() => setDeleteRequisitionModal(false)}> </DeleteApplication>*/}

                </IonModal>) : null}

    </React.Fragment>
    )
}